import request from "@/utils/request.js"

// 理疗师-新增(跨租户)
export const addTherapistIgnore = (formData) => {
    return request.post(`/therapist/ignoreTenant`, formData)
}

// 理疗师-详情(跨租户)
export const getTherapistIgnore = (id) => {
    return request.get(`/therapist/ignoreTenant/${id}`)
}

// 理疗师-修改(跨租户)
export const updateTherapistIgnore = (updateData) => {
    return request.put(`/therapist/ignoreTenant`, updateData);
};
